import { Section } from './Section';
import './ProblemSection.css';

const systems = ['raw material', 'exports', 'finance', 'production', 'logistics', 'compliance'];
const questions = [
  'Which inventory, batches, containers, customers, and contracts are affected?',
  'Which commitments are at risk?',
  'Which alternatives are operationally possible and commercially viable?',
  'What will happen to margins, spoilage risk, compliance, and customer service?',
  'What should the enterprise do next?',
];

function FragmentationMap() {
  return (
    <div className="fragmentation-map" aria-label="Fragmented enterprise information">
      <div className="fragmentation-map__systems">
        {systems.map((system) => (
          <span key={system}>{system}</span>
        ))}
      </div>
      <div className="fragmentation-map__people">
        People across sales, operations, plants, logistics, export, and finance each hold part of
        the picture.
      </div>
      <div className="fragmentation-map__reality">
        fragmented information, spreadsheets, phone calls, and human experience.
      </div>
    </div>
  );
}

export function ProblemSection() {
  return (
    <Section id="problem" tone="muted" className="problem-section">
      <div className="problem-section__intro-grid">
        <div className="problem-section__intro">
          <h2>The enterprise has information. It needs intelligence.</h2>
          <div className="problem-section__copy">
            <p>
              A seafood exporter may have separate systems for raw material, exports, finance,
              production, logistics, and compliance. People across sales, operations, plants,
              logistics, export, and finance each hold part of the picture.
            </p>
            <p>
              The result is that critical decisions remain dependent on fragmented information,
              spreadsheets, phone calls, and human experience.
            </p>
          </div>
        </div>
        <FragmentationMap />
      </div>
      <div className="problem-section__questions">
        <p className="problem-section__questions-intro">
          When conditions change, management needs answers to questions such as:
        </p>
        <ol>
          {questions.map((question) => (
            <li key={question}>{question}</li>
          ))}
        </ol>
      </div>
      <div className="problem-section__transition">
        <p>Traditional ERP records what happened. Business intelligence helps explain what happened.</p>
        <p>
          The next layer is enterprise intelligence: understanding the relationships, interpreting
          changes, evaluating alternatives, applying rules, and producing a coordinated decision.
        </p>
      </div>
    </Section>
  );
}
